import { Component, DestroyRef, inject, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { faArrowAltCircleLeft } from '@fortawesome/pro-solid-svg-icons';
import { forkJoin, Observable } from 'rxjs';
import { Room } from '../../models/storage/room';
import { FilterResults} from '../../../core/widgets/kw-filter-dropdown/models/filter-results'
import * as _ from 'underscore'
import { ErrorService } from '../../../../@core/utils/error.service';
import { StorageByRoomItem } from '../../../modules/pick-plan/pages/storage-by-room/storage-by-room-table/storageByRoomItem'
import { HarvestStorageDataService } from '../../../modules/pick-plan/services/harvest-storage-data.service';
import { CropYearService } from '../../services/crop-year.service';
import { KW_COLORS } from '../../../../@theme/kragworks-colors';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { PickPlanSessionService } from '../../../modules/pick-plan/services/pick-plan-session.service';
import { StorageByActionsDialogComponent } from '../../../modules/pick-plan/pages/storage-by-pool/storage-by-actions-dialog/storage-by-actions-dialog.component';
import { ChartConfiguration, ChartDataset, ChartOptions, ChartType, ChartTypeRegistry, TooltipItem } from 'chart.js/auto';
import { ReceivingSummaryItem } from '../../../modules/pick-plan/models/receiving-summary-item';
import { RoomCustomAttrabute } from '../../models/storage/room-custom-attrabute';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'room-summary',
  templateUrl: './room-summary.component.html',
  styleUrls: ['./room-summary.component.scss']
})
export class RoomSummaryComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  
  public faArrowAltCircleLeft = faArrowAltCircleLeft;

  public room: Room = {};
  public filterResults: FilterResults;
  public roomData: StorageByRoomItem;
  public roomLoading = true;
  public cropYearId: number;
  faBars = faBars;

    //Bar Chart Variables ---------------------------
    receivedBarData: number[] = [];
    plannedBarData: number[] = [];
    showAll: boolean = true;
    receivedBarQTYData: number[] = [];
    public allBarChartData: ChartDataset[] = [];
    //public barChartData: ChartDataset[] = [];
    public allBarChartLabels: string[] = [];
    public barChartLabels: string[] = [];
    filledRoomTolerance: number = .75;
    public barColor: string[] = [KW_COLORS.blue];
    // TODO Upgrade
    public barChartType: ChartType = 'bar';
    public barChartLegend: boolean = false;
    @Input() receivingData: ReceivingSummaryItem[] = [];
    public tableData: StorageByRoomItem[] = []
    public attrabutes: RoomCustomAttrabute[] = [];

    public barChartOptions: ChartOptions =
    {
      responsive: true,
      indexAxis: "y",
      maintainAspectRatio: false,
      plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        // disable due to bugs
        enabled: false,
        mode: 'index',
        callbacks: {
          label: function(tooltipItem: TooltipItem<keyof ChartTypeRegistry>) {
            let data = tooltipItem.dataset;
            var label = data[tooltipItem.datasetIndex].label;
            var value = data[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
  
            // Loop through all datasets to get the actual total of the index
            var total = 0;
            for (var i = 0; i < data.data.length; i++)
              total = total + +data[i].data[tooltipItem.dataIndex];
  
            // If it is not the last dataset, you display it as you usually do
            if (tooltipItem.datasetIndex != data.data.length - 1) {
              return label + " : " + value;
            } else { // .. else, you display the dataset and the total, using an array
              return [label + " : " + value, "Room Capacity: " + total];
            }
          },
          title: function (tooltipItem) {
            return "Room Data";
          }
        }
  
      },
    },
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false
          },
        },
        y: {
          stacked: true,
          grid: {
            display: false
          }
        }
      },
       
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
  
      }
    };

  public barChartColors: any[] = [
    KW_COLORS.planned,
    KW_COLORS.capacity,
    KW_COLORS.lightGray
  ]

  public chartData: ChartConfiguration;

  public barChartData: ChartConfiguration<'bar'>['data'];
  constructor(
    public dialogRef: MatDialogRef<RoomSummaryComponent>,
    public ReportsService: HarvestStorageDataService,
    private errorService: ErrorService,
    public cropYearService: CropYearService,
    private pickPlanSessionService: PickPlanSessionService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data
    ) { 
    if(this.data.room){
      this.room = {... this.data.room}
    }
    if(this.data.cropYear){
      this.cropYearId = this.data.cropYear
    }

    // this.chartData = {
    //   type: "bar",
    //   data: {
    //     datasets: [
    //       {
    //         data: this.roomData?.data,
    //         backgroundColor: this.barChartColors,
    //       },
    //     ],
    //   },
    //   options: {
    //     indexAxis: "y", // This makes the bar chart horizontal
    //   },
    // };

  }

  ngOnInit() {

    forkJoin([this.ReportsService.getStorageByRoomItemById(this.room.id, this.cropYearId)])
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:data => {
        this.roomData = data[0];
        this.roomLoading = false;
        this.parseData();
      }, error:err => {
        this.roomLoading = false;
        this.errorService.handleError(err);
      }});
  }
  openDialog(storageByRoomItem: StorageByRoomItem) {
    this.pickPlanSessionService.storageByRoomItem = storageByRoomItem;
    this.pickPlanSessionService.selectedCropYearId = this.cropYearId;
    const dialogRef = this.dialog.open(StorageByActionsDialogComponent, {
      width: '280px',
      data: {
        room: storageByRoomItem,
        cropYearId: this.cropYearId
      }
    }).afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      if(result){
        this.dialogRef.close();
      }
      // this.getPageData();
    });
  }
  
  close() {
    this.dialogRef.close();
  }

  parseData(){
    if(this.roomData?.data?.length >0){

      this.roomData['graphData'] = {
        labels: [''],
        datasets:this.roomData.data,
      };
    }
  }

}
